import { useState } from 'react'

import { useConfigureModalController, useModalController, useCloseModal } from '@/atoms'

type ModalState = 'ready' | 'submitting'
type ModalData = {
  userIds: string[]
}

export const modalId = 'deleteUserConfirmationModal'

export const useController = () => useModalController<ModalData, ModalState>(modalId)

export const useConfigureController = (userIds: string[]) => {
  const close = useCloseModal()

  // INITIALIZATION

  const [options] = useState(() => ({
    createInitialState: () => ({
      close,
      data: {
        userIds,
      },
    }),
  }))

  return useConfigureModalController<ModalData, ModalState>(modalId, options)
}
